import { createValidator } from 'revalidate';
import { INVALID_EMAIL_ADDRESS } from '../constants/defaultErrorMessages';
const validEmailPattern = /^\S+@\S+\.\S+$/;
const isValidEmail = createValidator(message => value => {
  return value && !validEmailPattern.test(value.trim()) ? message || INVALID_EMAIL_ADDRESS : null;
}, INVALID_EMAIL_ADDRESS);
export default isValidEmail;
//# sourceMappingURL=isValidEmail.js.map